import { render, staticRenderFns } from "./SimpleCurrencyInput.vue?vue&type=template&id=37a6deaa&"
import script from "./SimpleCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./SimpleCurrencyInput.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCurrencyInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports